module.exports = __webpack_public_path__ + "img/neuter.846c89e2.svg";